// TODO - Type 'any' needs to be fixed.
// import Button from "@gigandtake/button";

import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import {
  FormControl,
  InputAdornment,
  MenuItem,
  SelectChangeEvent, Skeleton,
  TextField
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface ISchedulerHeaderProps {
	activeTab: string;
	setActiveTab: Dispatch<SetStateAction<string>>;
	selectedLocation: number;
	handleLocationChange: (event: SelectChangeEvent<{ value: string }>) => void;
	allLocations: { id: number; name: string }[];
  ftSchedulerEnabledLocations:  { id: number; name: string }[];
}

const FullTimeSchedulerHeader: React.FC<ISchedulerHeaderProps> = ({
	activeTab,
	setActiveTab,
	selectedLocation,
	handleLocationChange,
	allLocations,
  ftSchedulerEnabledLocations,
}) => {
  const { t } = useTranslation();
  const getValidSelectedLocation = (id: number) => {
    try {
      const location = ftSchedulerEnabledLocations.find(
        (location: { id: number }) => location.id === id
      );
      return location ? location.id : ftSchedulerEnabledLocations[0].id; // Return the first location if not found
    } catch (error) {
      return null;
    }
  };
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-start",
				justifyContent: "center",
				background: "#fff",
				padding: "24px 24px 0px 24px",
				borderRadius: "15px 15px 0px 0px",
			}}
		>
			<Typography
				sx={{
					fontFamily: "Roboto",
					fontSize: "24px",
					fontWeight: 400,
					color: "rgba(0,0,0,0.87)",
				}}
			>
				{t("full-time-scheduler_advanced-schedule")}
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					alignItems: "center",
					textAlign: "center",
					height: "41px",
					width: "100%",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						height: "100%",
						alignItems: "flex-end",
						justifyContent: "flex-start",
					}}
				>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							padding: "8px 0px 8px 0px",

							borderBottom: activeTab === "SHIFTS" ? "1px solid #2F4D8B" : "",
							cursor: "pointer",
						}}
						onClick={() => {
							setActiveTab("SHIFTS");
						}} // False for shift
					>
						<Typography
							sx={{
								fontFamily: "Roboto",
								color:
									activeTab === "SHIFTS" ? "#2F4D8B" : "rgba(0, 0, 0, 0.60)",
								fontSize: "14px",
								fontWeight: "500",
								lineHeight: "24px",
								letterSpacing: "0.4px",
								textTransform: "uppercase",
							}}
						>
							{t("full-time-scheduler_shifts")}
						</Typography>
					</Box>
					<Box
						sx={{
							display: "flex",
							alignItems: "flex-start",
							justifyContent: "center",
							padding: "8px 0px 8px 0px",

							marginLeft: "24px",
							borderBottom: activeTab === "WORKERS" ? "1px solid #2F4D8B" : "",
							cursor: "pointer",
						}}
						onClick={() => {
							setActiveTab("WORKERS");
						}} // True for Availability
					>
						<Typography
							sx={{
								fontFamily: "Roboto",
								color:
									activeTab === "WORKERS" ? "#2F4D8B" : "rgba(0, 0, 0, 0.60)",
								fontSize: "14px",
								fontWeight: "500",
								lineHeight: "24px",
								letterSpacing: "0.4px",
								textTransform: "uppercase",
							}}
						>
							{t("full-time-scheduler_workers")}
						</Typography>
					</Box>
				</Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={-9}
        >
          {allLocations?.length === 0 && (
            <Skeleton variant={"rounded"} height={40} width={220} />
          )}
          {ftSchedulerEnabledLocations?.length === 1 && (
            <Box sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "40px",
              borderRadius: "4px",
              cursor: "default",
              padding: "8px 12px 8px 8px",
              backgroundColor: "rgba(0,0,0,0.02)",
            }}>
              {/* Icon on the left when only one location */}
              <LocationOnOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)", mr: 0.5 }} />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  color: "rgba(0,0,0,0.87)",
                  borderRadius: "4px",
                  lineHeight: "40px",
                  textAlign: "left",
                }}
              >
                {ftSchedulerEnabledLocations[0]?.name}
              </Typography>
            </Box>
          )}
          {ftSchedulerEnabledLocations?.length > 1 && (
            // Multiple locations: show dropdown with icon inside the field
            <FormControl>
              <TextField
                id="location-select"
                select
                variant="outlined"
                value={getValidSelectedLocation(selectedLocation)}
                onChange={(event) =>
                  handleLocationChange(
                    event as SelectChangeEvent<{ value: string }>
                  )
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <LocationOnOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  minWidth: "220px",
                  height: "40px",
                  borderRadius: "4px",
                  "& .MuiInputBase-root": {
                    height: "40px",
                    color: "rgba(0,0,0,0.6)",
                    borderRadius: "4px",
                  },
                }}
              >
                {ftSchedulerEnabledLocations.map((loc: { id: number; name: string }) => (
                  <MenuItem key={loc.id} value={loc.id}>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        color: "rgba(0,0,0,0.87)",
                        textAlign: "left",
                        lineHeight: "40px",
                      }}
                    >{loc.name}</Typography>
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}
        </Box>
			</Box>
		</Box>
	);
};

export default FullTimeSchedulerHeader;
